import React from 'react';
import { getStatusBadgeClass } from '../utils/format';

export default function StatusBadge({ status }) {
  return (
    <span className={getStatusBadgeClass(status)}>
      {status?.charAt(0).toUpperCase() + status?.slice(1)}
    </span>
  );
}
